export interface FullNameParts {
  lastName: string;
  firstName: string;
  middleName: string;
}

export function splitFullName(fullName?: string | null): FullNameParts {
  const trimmed = (fullName || '').trim();
  if (!trimmed) {
    return { lastName: '', firstName: '', middleName: '' };
  }
  const parts = trimmed.split(/\s+/);
  if (parts.length === 1) {
    return { lastName: parts[0], firstName: '', middleName: '' };
  }
  if (parts.length === 2) {
    return { lastName: parts[0], firstName: parts[1], middleName: '' };
  }
  return {
    lastName: parts[0],
    firstName: parts[1],
    middleName: parts.slice(2).join(' '),
  };
}

export function joinFullName(parts: FullNameParts): string {
  const lastName = (parts.lastName || '').trim();
  const firstName = (parts.firstName || '').trim();
  const middleName = (parts.middleName || '').trim();
  return [lastName, firstName, middleName].filter(Boolean).join(' ').trim();
}
